import { SafeResourceUrl } from '@angular/platform-browser';

export class Media {
    mediaUrl: string;
    smallUrl: string;
    mediumUrl: string;
    mediaType: MediaType;
    mediaId: string;
    mediaFilename: string;
    startTime: number;
    endTime: number;
    videoId: string;
    videoIframeUrl: SafeResourceUrl;
}

export enum MediaType {
    image = 1,
    youtubeVideo = 2,
    document = 3
}



// WEBPACK FOOTER //
// C:/ProactiView/ProactiView-Client/src/app/core/models/media.model.ts